import React from 'react';
import Modal from '@mui/material/Modal';
import './ModalWrapper.scss';

const ModalWrapper = ({ open, onClose, children }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="modal-content-wrapper">
        <div className="close-button">
          <button onClick={onClose}>✖</button>
        </div>
        <div className='modal-body'>
          
        {children}
        </div>
      </div>
    </Modal>
  );
};

export default ModalWrapper;
